(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {OUTSIDE_FABRICS,INSIDE_FABRICS,LENGTHS,WIDTHS,FOOTBOXES,INSULATION,COLLARS,COMPRESSION_SACK,STANDARD_COMPONENTS}=window.SLDEstimatorData.products["eclipse"];
const CONTROLS=window.SLDEstimatorData.productControls.eclipse;

  const FIELD_LABELS = Object.freeze({
    'Outside Fabric/Color\n*\n(required)': 'Outside Fabric',
    'Inside Fabric/Color\n*\n(required)': 'Inside Fabric',
    'Length\n*\n(required)': 'Length',
    'Width\n*\n(required)': 'Width',
    'Insulation Weight\n*\n(required)': 'Insulation',
    'Collar Type\n*\n(required)': 'Collar',
    'Footbox\n*\n(required)': 'Footbox',
    'Compression Sack\n*\n(required)': 'Compression Sack'
  });

  
  

  
  
  
  
  
  
  const DEFAULTS = Object.freeze({
    Width: 'Standard',
    Insulation: 'Apex Climashield 2.5 (50°F)',
    Collar: 'None',
    Footbox: 'Medium',
    'Compression Sack': 'No'
  });
  
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function upperWidth(width, outside, inside) {
    if (width === 'standard') return 51;
    if (width === 'wide') return outside.family === 'Ion' && inside.family === 'Ion' ? 59 : 58;
    return null;
  }

  function cinchCollar(rawWidth, density) {
    const shell = 3 * rawWidth / 1296 * density;
    const shockCord = (rawWidth + 10) * CONTROLS.shockCordWeightPerInch;
    return shell + shockCord + CONTROLS.cinchHardware;
  }

  function draftCollar(rawWidth, density, directClass) {
    if (directClass === 'standard-ion') return CONTROLS.draftDirectStandardIon;
    if (directClass === 'wide-argon') return CONTROLS.draftDirectWideArgon;
    const shell = 2 * 6 * rawWidth / 1296 * density;
    const collarInsulation = 6 * rawWidth / 1296 * window.SLDEstimatorData.shared.insulation.draftCollar.planningDensity;
    const shockCord = (rawWidth + 10) * CONTROLS.shockCordWeightPerInch;
    return shell + collarInsulation + shockCord + CONTROLS.draftHardware;
  }

  function collarWeight(type, widthChoice, rawWidth, outside, inside) {
    if (type === 'none') return 0;
    const density = Math.max(outside.density, inside.density);
    if (type === 'cinch') return cinchCollar(rawWidth, density);
    if (type === 'draft') {
      const directClass = widthChoice === 'Standard' && outside.family === 'Ion' && inside.family === 'Ion'
        ? 'standard-ion'
        : widthChoice === 'Wide' && outside.family === 'Argon' && inside.family === 'Argon'
          ? 'wide-argon'
          : '';
      return draftCollar(rawWidth, density, directClass);
    }
    return null;
  }

  function sackWeight(finished) {
    if (finished <= 15) return CONTROLS.sacks.le15;
    if (finished <= 17) return CONTROLS.sacks.le17;
    if (finished <= 19) return CONTROLS.sacks.le19;
    if (finished <= 22) return CONTROLS.sacks.le22;
    if (finished <= 25) return CONTROLS.sacks.le25;
    if (finished <= 28) return CONTROLS.sacks.le28;
    if (finished <= 32) return CONTROLS.sacks.le32;
    return CONTROLS.sacks.gt32;
  }

  function formatWeight(ounces) {
    return ounces.toFixed(1) + ' oz';
  }

  function estimate(choice) {
    const outside = OUTSIDE_FABRICS[choice['Outside Fabric']];
    const inside = INSIDE_FABRICS[choice['Inside Fabric']];
    const length = LENGTHS[choice.Length];
    if (!outside || !inside || !length) return null;

    const widthChoice = preference(choice, 'Width');
    const insulationChoice = preference(choice, 'Insulation');
    const collarChoice = preference(choice, 'Collar');
    const footboxChoice = preference(choice, 'Footbox');
    const compressionChoice = preference(choice, 'Compression Sack');
    const width = WIDTHS[widthChoice];
    const insulationDensity = INSULATION[insulationChoice];
    const collarType = COLLARS[collarChoice];
    const footbox = FOOTBOXES[footboxChoice];
    const compressionSack = COMPRESSION_SACK[compressionChoice];
    if (!width || insulationDensity === undefined || collarType === undefined || !footbox || compressionSack === undefined) return null;

    const rawWidth = upperWidth(width, outside, inside);
    const area = rawWidth * length.upperStraight
      + ((rawWidth + footbox.lowerTaperWidth) / 2) * length.taperVertical
      + footbox.footboxWidth * footbox.footboxVertical;
    const areaSqYd = area / 1296;
    const outsideWeight = areaSqYd * outside.density;
    const insideWeight = areaSqYd * inside.density;
    const apexWeight = areaSqYd * insulationDensity;
    const collar = collarWeight(collarType, widthChoice, rawWidth, outside, inside);
    if (collar === null) return null;
    const finished = outsideWeight + insideWeight + apexWeight + STANDARD_COMPONENTS + collar;
    return {
      area_sq_in: area,
      upper_width: rawWidth,
      outside_shell_weight: outsideWeight,
      inside_shell_weight: insideWeight,
      apex_weight: apexWeight,
      standard_components_weight: STANDARD_COMPONENTS,
      collar_weight: collar,
      finished_quilt_weight: finished,
      stuff_sack_weight: sackWeight(finished),
      compression_sack_weight: null,
      compression_sack_class: 'unclassified',
      compression_sack_selected: compressionSack
    };
  }

  function start() {
    const root = document.querySelector('[data-sld-eclipse-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the outside fabric, inside fabric, and length to see the estimated weight.';
        return;
      }
      const quilt = root.querySelector('[data-sld-weight-quilt]');
      const stuffSack = root.querySelector('[data-sld-weight-stuff-sack]');
      const compressionSack = root.querySelector('[data-sld-compression-sack]');
      if (quilt) quilt.textContent = formatWeight(result.finished_quilt_weight);
      if (stuffSack) stuffSack.textContent = formatWeight(result.stuff_sack_weight);
      if (compressionSack) compressionSack.textContent = result.compression_sack_selected
        ? '2–4 oz / 57–113 g'
        : 'Not selected';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return {
    COLLARS,
    COMPRESSION_SACK,
    FIELD_LABELS,
    FOOTBOXES,
    INSIDE_FABRICS,
    INSULATION,
    LENGTHS,
    OUTSIDE_FABRICS,
    WIDTHS,
    collarWeight,
    draftCollar,
    estimate,
    formatWeight,
    sackWeight,
    selections,
    start,
    upperWidth
  };
});
